import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputSelectOptions,
  LoaderButton
} from 'components/molecules'
import PropTypes from 'prop-types'
import { Col, Row } from 'reactstrap'
import { PER_PAGE, PAYMENT_STATUS, SORT_DIR, SORT_BY } from 'domains/fast-sell-payment/constants'

const propTypes = {
  filterValues      : PropTypes.object,
  onClickSubmitForm : PropTypes.func,
  onClickReset      : PropTypes.func
}

const defaultProps = {
  onClickSubmitForm : () => { },
  onClickReset      : () => { }
}

const FastSellPaymentFilterForm = ({
  filterValues,
  onClickSubmitForm,
  onClickReset
}) => (
  <Formik
    initialValues={{
      product_name             : filterValues.product_name || '',
      credit_bank_account_name : filterValues.credit_bank_account_name || '',
      credit_bank_name         : filterValues.credit_bank_name || '',
      payment_status           : filterValues.payment_status || '',
      per_page                 : filterValues.per_page || '',
      sort_by                  : filterValues.sort_by || '',
      sort_dir                 : filterValues.sort_dir || ''
    }}
    enableReinitialize={ true }
    onSubmit={ onClickSubmitForm }
  >
    {
      ({ isSubmitting }) => (
        <Form>
          <Row>
            <Col>
              <InputField
                type='input'
                name='product_name'
                label='Nama Produk'
                placeholder="Cari dengan nama produk.."
              />
            </Col>

            <Col>
              <InputField
                type='input'
                name='credit_bank_name'
                label='Bank Tujuan'
                placeholder="Cari dengan bank tujuan.."
              />
            </Col>


            <Col>
              <InputField
                type='input'
                name='credit_bank_account_name'
                label='Nama Pemilik Rekening'
                placeholder="Cari dengan nama pemilik rekening.."
              />
            </Col>

            <Col>
              <InputField
                type={ 'select' }
                name={ 'payment_status' }
                label='Payment Status'
              >
                <InputSelectOptions
                  options={ PAYMENT_STATUS }
                />
              </InputField>
            </Col>
          </Row>

          <div className='d-flex justify-content-end'>
            <InputField
              type={ 'select' }
              formGroupClassName={ 'mr-3' }
              name={ 'sort_by' }
              label={ 'Sort By' }
              bsSize={ 'sm' }
            >
              <InputSelectOptions
                options={ SORT_BY }
              />
            </InputField>
            <InputField
              type={ 'select' }
              formGroupClassName={ 'mr-3' }
              name={ 'sort_dir' }
              label={ 'Sort Dir' }
              bsSize={ 'sm' }
            >
              <InputSelectOptions
                options={ SORT_DIR }
              />
            </InputField>

            <InputField
              type={ 'select' }
              name={ 'per_page' }
              label={ 'Per Page' }
              bsSize={ 'sm' }
            >
              <InputSelectOptions
                options={ PER_PAGE }
              />
            </InputField>
          </div>

          <div className='d-flex'>
            <LoaderButton
              color='primary'
              className='mt-auto'
              type='submit'
              disabled={ isSubmitting }
              isLoading={ isSubmitting }
              text='Filter'
            />
            <LoaderButton
              color='danger'
              disabled={ isSubmitting }
              isLoading={ isSubmitting }
              text='Reset'
              onClick={ onClickReset }
            />

          </div>
        </Form>
      )
    }
  </Formik>
)

FastSellPaymentFilterForm.propTypes    = propTypes
FastSellPaymentFilterForm.defaultProps = defaultProps

export default FastSellPaymentFilterForm
